import axios from "axios";
import router from "@/router";
import store from "@/vuex";
import { Notification } from "element-ui";

// 创建axios实例
const service = axios.create({
  timeout: 60000, // 默认请求超时时间,不满足在api请求函数中传入参数timeout  之前默认为10000
});

let admin = null;

let warningShown = false; // 标志是否已经显示了警告

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    admin = config.admin;
    if (admin) {
      if (store.getters.adminToken) {
        config.headers["Authorization"] = store.getters.adminToken;
        config.headers["X-Requested-With"] = "XMLHttpRequest";
      }
    } else {
      if (store.getters.token) {
        config.headers["Authorization"] = store.getters.token;
        config.headers["X-Requested-With"] = "XMLHttpRequest";
      }
    }
    // 增加noLoading字段判断是否需要loading(默认loading)

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (res) => {
    const status = res.status;
    if (status === 200 && res.data.success) {

      warningShown = false; // 复位warningShown状态
      return res.data.content;
    } else if (
      status === 200 &&
      !res.data.success &&
      res.data.error &&
      res.data.error.code === "InvalidToken"
    ) {

      if (!warningShown) {
        warningShown = true;
        // 其他代码...

        if (res.data.error.message) {
          Notification.warning({
            title: "警告",
            message: res.data.error.message,
          });
        } else {
          Notification.warning({
            title: "警告",
            message: "登录过期，请重新登录",
          });
        }

        if (admin) {
          console.error(router);
          store.dispatch("AdminLogOut").then(() => {
            location.reload();
            router.push({
              path: "/background/login",
            });
          });
        } else {
          store.dispatch("LogOut").then(() => {
            //location.reload()
            router.push({
              path: "/login",
            });
          });
        }
      }

      return Promise.reject(res.data.error.message);
    } else {

      if (!warningShown) {
        warningShown = true;
        // 其他代码...
        Notification.warning({
          title: "警告",
          message: res.data.error.message,
        });
      }

      return Promise.reject(res.data.error);
    }
  },
  (err) => {
    // 对响应错误做点什么
    const message = err.message;
    if (message.includes("404")) {
      err.message = "404:服务器故障";
    } else if (message.includes("500")) {
      err.message = "500:服务器故障";
    } else if (message.includes("502")) {
      err.message = "502:服务器故障";
    } else if (err.message.includes("timeout")) {
      err.message = "请求超时,请刷新重试";
    } else {
      err.message = "未知错误";
    }

    if (!warningShown) {
      warningShown = true;
      // 其他代码...
      Notification.error({
        title: "错误",
        message: "网络异常，请刷新重试！",
      });
    }

    return Promise.reject(err.message);
  }
);

export default service;
